import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class CountUpView extends BaseView {
    private _winWaysText: PIXI.Text;
    private _layer: ScalableLayer;
    private _bitmapText: BasicBitmapCountUp;
    private _winTextShadow: PIXI.Sprite;

    constructor() {
        super();
    }

    public getWinStepAnimation(from: number, to: number, duration: number, totalWinWaysWon: number, ease: Ease = Linear.easeNone): TimelineLite {
        this._bitmapText.preCalculateScale(from, to);

        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            let winWayNum: string = totalWinWaysWon.toString();
            if (totalWinWaysWon === 1) {
                this._winWaysText.text = winWayNum + Translation.translate(" way won");
            } else {
                this._winWaysText.text = winWayNum + Translation.translate(" ways won");
            }
        });
        tl.add(
            () => new TweenLite(this._winWaysText, 0.1, {alpha: 1})
        );
        tl.add(() => {
            this._layer.addChild(this);
        });
        tl.add([
            () => this._bitmapText.getCountAnimation(from, to, duration, ease),
            TweenLite.to({}, duration, {})
        ]);
        return tl;
    }

    public abort(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(()=>{
            this._layer.addChild(this);
        })
        tl.add(() => this._bitmapText.stopAt(value));
        return tl;
    }

    public moveCountUp(value: number, displayDuration: number, fadeDuration: number, shouldNotMove: boolean, totalWinWaysWon: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
        });
        tl.add(() => this.fadeAndRemove(fadeDuration), tl.totalDuration() + displayDuration);
        return tl;
    }

    public end(value: number, displayDuration: number, fadeDuration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._layer.addChild(this);
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
        });
        tl.add(() => this.fadeAndRemove(fadeDuration), displayDuration);
        return tl;
    }

    protected initAnimations(): void {
        this._layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.WIN_COUNT_UP.name);

        this._winTextShadow = new PIXI.Sprite(GameResources.getTextures("winAmountShadow")[0]);
        this._winTextShadow.name = "bigWinCountUpShadow";
        this._winTextShadow.anchor.set(0.5);
        this._winTextShadow.scale.set(2);
        this._winTextShadow.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT * 0.65);

        this._bitmapText = new BasicBitmapCountUp(TombOfAkhenatenTextStyles.WIN_COUNT_UP, 550, new PIXI.Point(0.5, 0.5));
        this._bitmapText.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT * 0.72);
        this._bitmapText.scale.set(0.85);
        this.addChild(this._winTextShadow, this._bitmapText);

        this._winWaysText = new PIXI.Text(Translation.translate(""), TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        this._winWaysText.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT * 0.8);
        this._winWaysText.anchor.set(0.5);
        this._winWaysText.scale.set(0.5);
        this._winWaysText.alpha = 0;
        this._winWaysText.name = "bigWinWaysText";

        this.addChild(this._winWaysText);
    }

    protected onResize(resizeData: IResizeData) {
        super.onResize && super.onResize(resizeData);

        if (resizeData.orientation === Orientation.PORTRAIT) {
            this.position.set(0, 0);
        } else {
            this.position.set(0, 60);
        }
    }

    public fadeAndRemove(fadeDuration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, fadeDuration, {alpha: 0, ease: Linear.easeNone}));
        tl.add(() => {
            this._layer.removeChild(this);
            this.alpha = 1;
            this._winWaysText.alpha = 0;
        });
        return tl;
    }
}